import { Provider } from '@angular/core';
import { forceBackToCurrentLocation } from '@bcf-v2-configurators/tokens/cashier/mobile-web-twa/force-back-to-current-location';
import { FORCE_BACK_TO_CURRENT_LOCATION } from '@bcf-v2-configurators/tokens/cashier/token';
import { TWA_IN_APP_REVIEW_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/twa-in-app-review/tokens';

export const settingsProviders: Provider[] = [
  {
    provide: FORCE_BACK_TO_CURRENT_LOCATION,
    useValue: forceBackToCurrentLocation
  },
  {
    provide: TWA_IN_APP_REVIEW_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/twa-in-app-review/lvbetcom/casino/mobile-web-twa/twa-in-app-review-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.twaInAppReviewConfig
      )
  }
];
